import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileSidebarVisible, setIsMobileSidebarVisible] = useState(false);

  // Check for mobile screen size
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // Auto-collapse on mobile
      if (mobile) {
        setIsCollapsed(true);
        setIsMobileSidebarVisible(false); // Hide mobile sidebar when switching to mobile
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) {
      setIsMobileSidebarVisible(prev => !prev);
    } else {
      setIsCollapsed(prev => !prev);
    }
  };

  const collapseSidebar = () => {
    if (isMobile) {
      setIsMobileSidebarVisible(false);
    } else {
      setIsCollapsed(true);
    }
  };

  const expandSidebar = () => {
    if (isMobile) {
      setIsMobileSidebarVisible(true);
    } else {
      setIsCollapsed(false);
    }
  };

  const showMobileSidebar = () => {
    setIsMobileSidebarVisible(true);
  };

  const hideMobileSidebar = () => {
    setIsMobileSidebarVisible(false);
  };

  const value = {
    isCollapsed,
    isMobile,
    isMobileSidebarVisible,
    toggleSidebar,
    collapseSidebar,
    expandSidebar,
    showMobileSidebar,
    hideMobileSidebar,
    setIsCollapsed
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
}; 